module.exports = __webpack_public_path__ + "static/img/1.34552d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/1.png
// module id = TjfP
// module chunks = 0